import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './style/index.css';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import DocCategoryConfig from './pages/DocCategoryConfig';
import DocModelConfig from './pages/DocModelConfig';
import MainConfig from './pages/MainConfig';
import NewModelDoc from './pages/NewModelDoc';
import Error from './pages/Error';
import EditModel from './pages/EditModel';

import Users from './pages/Users';
import EditDocumentsUsers from './pages/EditDocumentsUsers';
import reportWebVitals from './reportWebVitals';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
      <Route path="/dashboard" element={<Dashboard />} />

      <Route path='/' element={<Login/>}/>
      
        <Route path="/configuration/globale" element={<MainConfig />} />
        <Route path="/configuration/documents/categories" element={<DocCategoryConfig />} />
        <Route path="/configuration/documents/modeles" element={<DocModelConfig />} />
        <Route path="/configuration/documents/modeles/nouveau" element={<NewModelDoc />} />
        <Route path="/configuration/documents/modeles/modifier/:modelId" element={<EditModel />} />
        <Route path='/inventaire/utilisateurs' element={<Users/>}/>
        <Route path='/inventaire/utilisateurs/:userId' element={<EditDocumentsUsers/>}/>
  

       
 
        <Route path="*" element={<Error />} />
</Routes></Router>
  </React.StrictMode>
);

reportWebVitals();
